import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionHeader } from 'legacyComponents/layout/sectionHeader';
import { CardSection } from 'legacyComponents/layout/cardSection';

import { FourOhFour } from 'apps/fourOhFour/index';
import Header from 'apps/components/header/header';

import {
  InnerWrapper,
  ActivityWrapper,
  Blured,
  Sticky,
  SidebarWrapper,
} from 'apps/home/activityFeed/styles';
import { GlobalActivityManager } from 'apps/home/activityFeed/globalActivity/appManager';
import { ActivityCard } from 'apps/home/activityFeed/views/activityCard';
import { ProjectSidebar } from 'apps/home/activityFeed/views/projectSidebar';
import { AnnouncementSidebar } from 'apps/home/activityFeed/views/announcementSidebar';

@withNamespaces()
@inject('clientStore')
@observer
export class GlobalActivity extends React.Component {
  constructor(props) {
    super(props);
    const { clientStore } = props;
    if (clientStore.signedInProfile) {
      this.appManager = new GlobalActivityManager(null, {});
    }
  }

  render() {
    const { clientStore } = this.props;
    if (!clientStore.signedInProfile) {
      return <FourOhFour />;
    }
    const { activitiesConn, SetActiveTab } = this.appManager;
    const activities = activitiesConn.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <InnerWrapper>
            <ActivityWrapper>
              <Blured />
              <Sticky hasBanner={clientStore.hasBanner}>
                <SectionHeader
                  activeTab='globalFeed'
                  handleTabClick={SetActiveTab}
                  tabs={[
                    ['myFeed', <Trans key='text'>My Feed</Trans>, false],
                    [
                      'globalFeed',
                      <Trans key='text'>Global Feed</Trans>,
                      false,
                    ],
                  ]}
                />
              </Sticky>

              <CardSection
                key='globalActivity-section'
                title=''
                createHandler={() => ''}
                cardApp={activities}
                CardComponent={ActivityCard}
                noDataCardType='activity'
              />
            </ActivityWrapper>
            <SidebarWrapper hasBanner={clientStore.hasBanner}>
              <AnnouncementSidebar />
              <ProjectSidebar projects={this.appManager.contributedProjects} />
              {/* <TeamSidebar /> */}
            </SidebarWrapper>
          </InnerWrapper>
        </MainWrapper>
      </>
    );
  }
}

GlobalActivity.propTypes = {
  clientStore: PropTypes.object,
  t: PropTypes.func,
};
